import { SonarScopedDashboardPage } from './sonar/shared/components/SonarScopedDashboardPage';

export const SonarRepoViewPage = () => (
  <SonarScopedDashboardPage initialScope="repository" />
);